export default __webpack_public_path__ + "static/media/icon-diams.091e0ce9.png";